<div class="google-reviews-section">
  <div class="section-title" *ngFor="let Content of sectionTitle;">
    <h1>{{Content.title}}</h1>
    <p>{{Content.paragraph}}</p>
  </div>
  <div class="google-reviews-header-row">
    <div class="google-logo-rating">
      <img src="https://www.gstatic.com/images/branding/product/1x/googleg_32dp.png" alt="Google" class="google-logo" />
      <span class="google-rating">4.6</span>
      <span class="google-stars">
        <ng-container *ngFor="let star of [].constructor(5)">&#9733;</ng-container>
      </span>
      <span class="google-review-count">(39)</span>
    </div>
    <!-- <button class="write-review-btn">Write a review</button> -->
  </div>
  <div class="google-reviews-carousel">
    <button class="carousel-arrow left" (click)="prevReview()">&#8592;</button>
    <div class="reviews-row">
      <div class="review-card" *ngFor="let review of visibleReviews">
        <div class="review-header">
          <ng-container *ngIf="review.image; else noImage">
            <img [src]="review.image" alt="Reviewer photo" class="review-avatar" (error)="review.image = null" />
          </ng-container>
          <ng-template #noImage>
            <div class="review-avatar-initial">{{ review.name.charAt(0) }}</div>
          </ng-template>
          <div class="reviewer-info">
            <div class="reviewer-name">{{ review.name }} <span class="verified"><i class="fa fa-check-circle"></i></span></div>
            <div class="reviewer-google"><img src="https://www.gstatic.com/images/branding/product/1x/googleg_32dp.png" alt="Google" class="google-mini-logo" /></div>
            <div class="review-date">{{ review.dateAgo }}</div>
          </div>
        </div>
        <div class="review-stars">
          <ng-container *ngFor="let star of [].constructor(review.rating)">&#9733;</ng-container>
        </div>
        <div class="review-text">
          <ng-container *ngIf="expandedReview !== review">
            {{ review.text | slice:0:90 }}<span *ngIf="review.text.length > 90">... <a href="#" (click)="$event.preventDefault(); expandReview(review)">Read more</a></span>
          </ng-container>
          <ng-container *ngIf="expandedReview === review">
            <span (click)="openModal(review)" style="cursor:pointer; color:#333; text-decoration:none;">{{ review.text }}</span>
            <a href="#" (click)="$event.preventDefault(); collapseReview()" style="margin-left:8px; font-size:0.95em;">Show less</a>
          </ng-container>
        </div>
        <div class="review-images" *ngIf="review.images">
          <img *ngFor="let img of review.images.slice(0,4)" [src]="img" class="review-img-thumb" />
          <span *ngIf="review.images.length > 4" class="more-images">+{{ review.images.length - 4 }}</span>
        </div>
      </div>
    </div>
    <button class="carousel-arrow right" (click)="nextReview()">&#8594;</button>
  </div>
</div>

<!-- Modal -->
<div class="modal-backdrop" *ngIf="modalOpen" (click)="closeModal()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <button class="close-btn" (click)="closeModal()">&times;</button>
    <img [src]="selectedReview?.image" alt="Reviewer photo" class="modal-img" />
    <div class="modal-name">{{ selectedReview?.name }}</div>
    <div class="modal-rating">
      <ng-container *ngFor="let star of [].constructor(selectedReview?.rating)">&#9733;</ng-container>
      <ng-container *ngFor="let star of [].constructor(5 - selectedReview?.rating)">&#9734;</ng-container>
    </div>
    <div class="modal-text">"{{ selectedReview?.text }}"</div>
    <div class="modal-date">{{ selectedReview?.dateAgo }}</div>
    <div class="modal-images" *ngIf="selectedReview?.images">
      <img *ngFor="let img of selectedReview.images" [src]="img" class="review-img-thumb" />
    </div>
  </div>
</div>